// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { UserService } from '@services/user.service';
import { Observable, map } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class VersionNumberResolver implements Resolve<{ versionNumber: string }[]> {
    constructor(private userService: UserService) {}

    resolve(): Observable<{ versionNumber: string }[]> {
        return this.userService.versionNumber$().pipe(map((version) => [{ versionNumber: version }]));
    }
}
